import React, { useState } from 'react';

const SendDialog = (props) => {
	const [loading, setLoading] = useState(false);
    const { isOpen, onConfirm, onClose, submitCallback } = props;

	const onSubmit = async (e) => {
		e.preventDefault();
		const formData = new FormData(e.target);
		const apiKey = formData.get('apiKey');
		try {
			setLoading(true);
			await submitCallback(apiKey);
		} catch(e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

    return (
        <div className={`modal ${isOpen ? 'show' : ''}`}>
            <div className="modal-content">
                <i className="icon icon-clear" onClick={onClose}></i>
                <h2>An FPS senden</h2>
                <hr className="line" />
                <form onSubmit={onSubmit}>
                    <label htmlFor='apiKey'>API Key</label>
                    <input id='apiKey' type="text" name="apiKey" required />
                    <p>Wollen Sie die Anfrage an FPS erneut senden?</p>
                    {!loading && (
                        <div className="flex">
                            <button className="btn btn-blue" id="abort" onClick={onClose}>
                                Nein
                            </button>
                            <button className="btn" id="clear" onClick={onConfirm}>
                                Ja
                            </button>
                        </div>
                    )}
                    {loading && (
                        <div className={'loader show'}>
                            <img src="/img/loader.gif" alt="Ladebalken" title="Lädt" className={'loader show'} />
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};
export default SendDialog;
